





















import Onboarding from '@/util/Onboarding'
import { State, Action } from 'vuex-class'
import { Vue, Component } from 'vue-property-decorator'
import PStorage, { USERNAME, stored } from '@/util/PStorage'
import { RootState } from '@/store/types'
import { setPageTitle } from '@/util/Helpers'
import { INITIAL_CONNECT } from '@/store/ui/constants'
import UnlockInput from './UnlockInput.vue'

@Component({ components: { UnlockInput } })
export default class Unlock extends Vue {
    errorMessage: string | null = null
    loading: boolean = false

    @State((state: RootState) => state.ui.lastUrl)
    lastUrl?: string

    @Action(INITIAL_CONNECT)
    initialConnect!: () => Promise<void>

    mounted(): void {
        setPageTitle('Unlock')
    }

    async unlock(password: string): Promise<void> {
        try {
            Onboarding.unlock(password)
        } catch (err) {
            this.errorMessage = err.message || err
            return
        }

        this.loading = true
        this.$router.push(this.lastUrl || '/')
        setTimeout(async () => {
            try {
                await Onboarding.fetchToken()
                this.$info({
                    text: 'Sync enabled'
                })
                // begin sync
                this.initialConnect()
            } catch (err) {
                this.$error({
                    text: `
                        <span>
                            Couldn't authenticate with server, sync will be temporarily
                            disabled.
                            <br />
                            <strong>Error</strong>: ${err}
                        </span>
                    `,
                    timeout: 10000
                })
            }
        }, 100)
    }

    getUserName(): string {
        return stored.username
    }

    input(): void {
        this.loading = false
        this.errorMessage = null
    }
}
